module.exports = __webpack_public_path__ + "img/86ne.da1cf394.svg";